import { render, staticRenderFns } from "./dsjsjmx.vue?vue&type=template&id=cb742132&scoped=true&"
import script from "./dsjsjmx.vue?vue&type=script&lang=js&"
export * from "./dsjsjmx.vue?vue&type=script&lang=js&"
import style0 from "./dsjsjmx.vue?vue&type=style&index=0&id=cb742132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb742132",
  null
  
)

export default component.exports